import React from 'react';
import logoImage from '../../assets/images/logo.jpeg';

/**
 * Branded loading screen - shown while a lazy-loaded route (e.g. anything
 * under /admin) is being fetched. Was previously plain "Loading..." text
 * with no branding.
 */
const LoadingScreen = () => (
  <div style={{
    minHeight: '60vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16
  }}>
    <style>{`
      @keyframes loadingPulse {
        0%, 100% { opacity: 1; transform: scale(1); }
        50% { opacity: 0.6; transform: scale(0.96); }
      }
    `}</style>
    <img
      src={logoImage}
      alt="BusinessMate Workflow"
      style={{ height: 48, animation: 'loadingPulse 1.4s ease-in-out infinite' }}
    />
  </div>
);

export default LoadingScreen;
